// Designer Color Picker
(function() {
    'use strict';
    
    function initColorPicker(element) {
        const targetId = element.getAttribute('data-target');
        if (!targetId) return;
        
        const targetInput = document.getElementById(targetId);
        if (!targetInput) return;
        
        const initialColor = targetInput.value || '#FF0000';
        let currentHue = 0;
        let currentSat = 1;
        let currentBri = 1;
        
        // Create HTML
        element.innerHTML = `
            <div class="color-picker-btn" style="width: 100%; height: 100%; border: 1px solid #e1e1e1; border-radius: 8px; cursor: pointer; position: relative; background: ${initialColor};">
                <i class="fa-sharp fa-light fa-brush color-picker-icon" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: ${getLuminance(initialColor) > 0.5 ? '#000' : '#fff'};"></i>
            </div>
            <div class="color-picker-popup" style="display: none; position: absolute; top: 60px; left: 0; background: white; border: 1px solid #e1e1e1; border-radius: 12px; padding: 16px; box-shadow: 0 8px 24px rgba(0,0,0,0.15); z-index: 9999; min-width: 300px;">
                <div style="position: relative; width: 280px; height: 200px; margin-bottom: 12px;">
                    <canvas class="color-canvas" width="280" height="200" style="border-radius: 8px; cursor: crosshair; display: block;"></canvas>
                    <div class="color-cursor" style="position: absolute; width: 14px; height: 14px; border: 1px solid #e1e1e1; border-radius: 50%; pointer-events: none; box-shadow: 0 0 0 1px rgba(0,0,0,0.3); transform: translate(-50%, -50%);"></div>
                </div>
                <div style="position: relative; margin-bottom: 12px;">
                    <canvas class="hue-canvas" width="280" height="12" style="border-radius: 6px; cursor: pointer; display: block;"></canvas>
                    <div class="hue-indicator" style="position: absolute; top: 50%; width: 3px; height: 16px; background: white; border: 1px solid #e1e1e1; border-radius: 2px; transform: translate(-50%, -50%); pointer-events: none; box-shadow: 0 0 3px rgba(0,0,0,0.5);"></div>
                </div>
                <div style="margin-bottom: 12px;display: flex;">
                    <input type="text" class="hex-input" placeholder="#000000" maxlength="7" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 6px; font-family: monospace; text-align: center; font-size: 14px; text-transform: uppercase;">
                </div>
                <button class="close-btn" style="width: 100%; padding: 8px; background: #f0f0f0; border: 1px solid #ddd; border-radius: 6px; cursor: pointer; font-size: 13px;">Close</button>
            </div>
        `;
        
        const btn = element.querySelector('.color-picker-btn');
        const icon = element.querySelector('.color-picker-icon');
        const popup = element.querySelector('.color-picker-popup');
        const canvas = element.querySelector('.color-canvas');
        const ctx = canvas.getContext('2d');
        const cursor = element.querySelector('.color-cursor');
        const hueCanvas = element.querySelector('.hue-canvas');
        const hueCtx = hueCanvas.getContext('2d');
        const hueIndicator = element.querySelector('.hue-indicator');
        const hexInput = element.querySelector('.hex-input');
        const closeBtn = element.querySelector('.close-btn');
        
        // Draw smooth hue gradient
        function drawHueBar() {
            const gradient = hueCtx.createLinearGradient(0, 0, hueCanvas.width, 0);
            for (let i = 0; i <= 360; i += 10) {
                gradient.addColorStop(i / 360, `hsl(${i}, 100%, 50%)`);
            }
            hueCtx.fillStyle = gradient;
            hueCtx.fillRect(0, 0, hueCanvas.width, hueCanvas.height);
        }
        
        // Functions
        function getLuminance(hex) {
            const rgb = hexToRgb(hex);
            if (!rgb) return 0;
            const r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255;
            return 0.299 * r + 0.587 * g + 0.114 * b;
        }
        
        function hsbToRgb(h, s, b) {
            h = h / 360;
            const i = Math.floor(h * 6);
            const f = h * 6 - i;
            const p = b * (1 - s);
            const q = b * (1 - f * s);
            const t = b * (1 - (1 - f) * s);
            let r, g, bl;
            switch (i % 6) {
                case 0: r = b; g = t; bl = p; break;
                case 1: r = q; g = b; bl = p; break;
                case 2: r = p; g = b; bl = t; break;
                case 3: r = p; g = q; bl = b; break;
                case 4: r = t; g = p; bl = b; break;
                case 5: r = b; g = p; bl = q; break;
            }
            return {
                r: Math.round(r * 255),
                g: Math.round(g * 255),
                b: Math.round(bl * 255)
            };
        }
        
        function rgbToHex(r, g, b) {
            return '#' + [r, g, b].map(x => {
                const hex = x.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            }).join('').toUpperCase();
        }
        
        function hexToRgb(hex) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }
        
        function drawCanvas() {
            // Fill with current hue
            const rgb = hsbToRgb(currentHue, 1, 1);
            ctx.fillStyle = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            
            // Add white gradient (left to right)
            const whiteGrad = ctx.createLinearGradient(0, 0, canvas.width, 0);
            whiteGrad.addColorStop(0, 'rgba(255,255,255,1)');
            whiteGrad.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.fillStyle = whiteGrad;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            
            // Add black gradient (top to bottom)
            const blackGrad = ctx.createLinearGradient(0, 0, 0, canvas.height);
            blackGrad.addColorStop(0, 'rgba(0,0,0,0)');
            blackGrad.addColorStop(1, 'rgba(0,0,0,1)');
            ctx.fillStyle = blackGrad;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        function setColor(hex) {
            hex = hex.toUpperCase();
            btn.style.background = hex;
            icon.style.color = getLuminance(hex) > 0.5 ? '#000' : '#fff';
            hexInput.value = hex;
            targetInput.value = hex;
            
            // Trigger change and input events
            const changeEvent = new Event('change', { bubbles: true });
            const inputEvent = new Event('input', { bubbles: true });
            targetInput.dispatchEvent(changeEvent);
            targetInput.dispatchEvent(inputEvent);
        }
        
        // Events
        btn.onclick = (e) => {
            e.stopPropagation();
            const isVisible = popup.style.display === 'block';
            popup.style.display = isVisible ? 'none' : 'block';
            
            if (!isVisible) {
                // Position popup at cursor
                const rect = element.getBoundingClientRect();
                const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
                const scrollY = window.pageYOffset || document.documentElement.scrollTop;
                
                popup.style.position = 'fixed';
                popup.style.left = e.clientX + 'px';
                popup.style.top = (e.clientY + 10) + 'px';
                
                // Keep popup in viewport
                setTimeout(() => {
                    const popupRect = popup.getBoundingClientRect();
                    if (popupRect.right > window.innerWidth) {
                        popup.style.left = (window.innerWidth - popupRect.width - 10) + 'px';
                    }
                    if (popupRect.bottom > window.innerHeight) {
                        popup.style.top = (e.clientY - popupRect.height - 10) + 'px';
                    }
                }, 0);
                
                drawCanvas();
                drawHueBar();
            }
        };
        
        closeBtn.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            popup.style.display = 'none';
        };
        
        document.addEventListener('click', (e) => {
            if (!element.contains(e.target)) popup.style.display = 'none';
        });
        
        // Hide popup on scroll
        window.addEventListener('scroll', () => {
            popup.style.display = 'none';
        }, true);
        
        // Hide popup on right click outside
        document.addEventListener('contextmenu', (e) => {
            if (!element.contains(e.target)) popup.style.display = 'none';
        });
        
        let isDragging = false;
        
        function pickColor(e) {
            e.preventDefault();
            const rect = canvas.getBoundingClientRect();
            const touch = e.touches ? e.touches[0] : e;
            const x = Math.max(0, Math.min(280, touch.clientX - rect.left));
            const y = Math.max(0, Math.min(200, touch.clientY - rect.top));
            currentSat = x / 280;
            currentBri = 1 - (y / 200);
            const rgb = hsbToRgb(currentHue, currentSat, currentBri);
            setColor(rgbToHex(rgb.r, rgb.g, rgb.b));
            cursor.style.left = x + 'px';
            cursor.style.top = y + 'px';
        }
        
        // Mouse events
        canvas.onmousedown = (e) => {
            isDragging = true;
            pickColor(e);
        };
        canvas.onmousemove = (e) => {
            if (isDragging) pickColor(e);
        };
        document.addEventListener('mouseup', () => {
            isDragging = false;
        });
        
        // Touch events
        canvas.addEventListener('touchstart', (e) => {
            isDragging = true;
            pickColor(e);
        }, { passive: false });
        canvas.addEventListener('touchmove', (e) => {
            if (isDragging) pickColor(e);
        }, { passive: false });
        canvas.addEventListener('touchend', () => isDragging = false);
        
        let isHueDragging = false;
        
        function pickHue(e) {
            e.preventDefault();
            const rect = hueCanvas.getBoundingClientRect();
            const touch = e.touches ? e.touches[0] : e;
            const x = Math.max(0, Math.min(rect.width, touch.clientX - rect.left));
            currentHue = (x / rect.width) * 360;
            hueIndicator.style.left = x + 'px';
            drawCanvas();
            const rgb = hsbToRgb(currentHue, currentSat, currentBri);
            setColor(rgbToHex(rgb.r, rgb.g, rgb.b));
        }
        
        // Mouse events
        hueCanvas.onmousedown = (e) => {
            isHueDragging = true;
            pickHue(e);
        };
        hueCanvas.onmousemove = (e) => {
            if (isHueDragging) pickHue(e);
        };
        document.addEventListener('mouseup', () => isHueDragging = false);
        
        // Touch events
        hueCanvas.addEventListener('touchstart', (e) => {
            isHueDragging = true;
            pickHue(e);
        }, { passive: false });
        hueCanvas.addEventListener('touchmove', (e) => {
            if (isHueDragging) pickHue(e);
        }, { passive: false });
        hueCanvas.addEventListener('touchend', () => isHueDragging = false);
        
        hexInput.oninput = (e) => {
            let val = e.target.value.toUpperCase();
            if (!val.startsWith('#')) val = '#' + val;
            if (/^#[0-9A-F]{6}$/.test(val)) setColor(val);
        };
        
        // On paste in hex input, extract only 6 hex characters
        hexInput.addEventListener('paste', (e) => {
            e.preventDefault();
            let paste = (e.clipboardData || window.clipboardData).getData('text');
            let hex = paste.replace(/[^0-9A-Fa-f]/g, '').substring(0, 6);
            if (hex.length === 6) {
                hexInput.value = '#' + hex.toUpperCase();
                setColor('#' + hex.toUpperCase());
            }
        });
        
        // Outside input affects button background
        targetInput.addEventListener('input', (e) => {
            const hex = e.target.value;
            if (/^#[0-9A-F]{6}$/i.test(hex)) {
                btn.style.background = hex.toUpperCase();
                icon.style.color = getLuminance(hex) > 0.5 ? '#000' : '#fff';
                hexInput.value = hex.toUpperCase();
            }
        });
        
        setColor(initialColor);
        drawCanvas();
        drawHueBar();
    }
    
    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('mahmoud-colorpicker').forEach(initColorPicker);
        });
    } else {
        document.querySelectorAll('mahmoud-colorpicker').forEach(initColorPicker);
    }
})();
